/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/clock'
export default icon
